import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Liquid staking',
    stake: 'Stake',
    unstake: 'Unstake',
    claim: 'Claim',
  },
};
